// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export interface IFlipbookTexture {
  atlas_tile: string;
  flipbook_texture: string;
  ticks_per_frame: number;
}
